import React from 'react';
import {Transition, Segment} from 'semantic-ui-react';
import './FormContainer.css';

export default (props) => {
    return <Transition transitionOnMount={true} visible={props.visible} animation="zoom" duration={500} ><Segment basic className="info-segment" {...props} /></Transition>
}


// WEBPACK FOOTER //
// ./src/containers/FormContainer/FormContainerWrapper.jsx